var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84299 11.6337L10.7335 2.74324L19.6428 11.6526L10.7524 20.5431C8.28875 23.0067 4.30032 23.0067 1.84299 20.5431C-0.614331 18.0795 -0.614331 14.091 1.84299 11.6337Z",
    fill: "url(#paint0_radial_6355_3896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7331 11.653C13.1967 14.1166 17.1851 14.1166 19.6424 11.653C22.0998 9.18939 22.1061 5.20096 19.6424 2.74364C17.1788 0.286312 13.1904 0.286312 10.7331 2.74364C8.27573 5.20096 8.26943 9.19569 10.7331 11.653Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6424 11.6525L10.752 20.543L19.6613 29.4523L28.5518 20.5619C31.0154 18.0982 31.0154 14.1098 28.5518 11.6525C26.0882 9.19515 22.0997 9.19515 19.6424 11.6525Z",
    fill: "url(#paint1_radial_6355_3896)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6615 20.5435C22.1252 23.0071 22.1252 26.9955 19.6615 29.4529C17.1979 31.9102 13.2095 31.9165 10.7522 29.4529C8.29485 26.9892 8.29485 23.0008 10.7522 20.5435C13.2158 18.0799 17.2042 18.0799 19.6615 20.5435Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6355_3896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1101 7.0493) rotate(135) scale(18.808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6355_3896",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0533 24.927) rotate(-45) scale(18.808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8addb3fd1cf33c86134a9fe7a4a8c370.svg";
export { ForwardRef as ReactComponent };